export const USER_REQUEST = 'USER_REQUEST';
export const USER_SUCCESS = 'USER_SUCCESS';
export const USER_ERROR = 'USER_ERROR';
export const USER_LIST = 'USER_LIST';
export const USER_ADD = 'USER_ADD';
export const USER_UPDATE =  'UPDATE_USER';
export const USER_DELETE = 'USER_DELETE';
export const USER_CREATE_PASSWORD = 'USER_CREATE_PASSWORD';
export const RESET_USER_STORE = 'RESET_USER_STORE';
